import { render } from "./UniversityFilter.vue?vue&type=template&id=f9745e1c&scoped=true&ts=true"
import script from "./UniversityFilter.ts?vue&type=script&lang=ts&external"
export * from "./UniversityFilter.ts?vue&type=script&lang=ts&external"

import "./UniversityFilter.scss?vue&type=style&index=0&id=f9745e1c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9745e1c"]])

export default __exports__